export default __webpack_public_path__ + "static/media/phones.75ccc5df.png";